import React from 'react';

const EnterFlowContext = React.createContext<{} | null>(null);

export default EnterFlowContext;
